/* eslint-disable @typescript-eslint/ban-ts-comment */
import throttle from "just-throttle";
import memoize from "just-memoize";

import useActivityCenterStore, { type ActivityCenterStore } from "./Store";

export interface QueryNumberOfNewNotificationsDebounced {
  userId?: string;
  chatId?: string;
}

const updateNotificationBadge = (
  { userId, chatId }: QueryNumberOfNewNotificationsDebounced,
  activityCenterStore: ActivityCenterStore = useActivityCenterStore()
) => {
  activityCenterStore.getNumberOfNewNotifications(userId, chatId);
};

const wrap = <T = (v?: unknown) => unknown, V = unknown, R = unknown>(
  func: T,
  wrapperFunc: (arg1: T, arg2: V) => R
) => {
  return (v: V) => wrapperFunc(func, v);
};

export const debounceUpdateNotificationBadge = wrap(
  memoize<(p1: QueryNumberOfNewNotificationsDebounced, p2: ActivityCenterStore) => void>(
    () =>
      throttle(
        (p1: QueryNumberOfNewNotificationsDebounced, p2: ActivityCenterStore) => {
          updateNotificationBadge(p1, p2);
        },
        5000,
        { leading: true, trailing: false }
      ),
    (query: QueryNumberOfNewNotificationsDebounced) => query.userId as string
  ),
  // @ts-ignore
  (getMemoizedFunc, obj: QueryNumberOfNewNotificationsDebounced, p: ActivityCenterStore) =>
    // @ts-ignore
    getMemoizedFunc(obj)(obj, p)
) as (args0: QueryNumberOfNewNotificationsDebounced, args1: ActivityCenterStore) => void;
